import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 6000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()
  }
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status_code === 401 || res.status_code === 403) {
      MessageBox.confirm('你已被登出，请重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        customClass: 'logOut',
        type: 'warning',
        showClose: false
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload()    // 为了重新实例化vue-router对象 避免bug
        })
      }).catch(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload()    // 为了重新实例化vue-router对象 避免bug
        })
      })
      return Promise.reject('error')
    } else if (res.status_code === 500) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })
    } else {
      return response.data
    }
  },
  error => {
    Message({
      message: error.response.data.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/libs/request.js